import { useQuery } from "@tanstack/react-query";
import {
  getMarkets,
  getMovers,
  getMood,
  getAsset,
  getHistory,
} from "../lib/api";
import { classifyRecentDirection } from "../lib/recentDirection";

const FIVE_MIN = 5 * 60 * 1000;

const withRecentDirection = (asset) =>
  asset ? { ...asset, trend: classifyRecentDirection(asset) } : asset;

export const useMarkets = (category) =>
  useQuery({
    queryKey: ["markets", category || "all"],
    queryFn: async () => {
      const data = await getMarkets(category);
      return {
        ...data,
        markets: (data?.markets || []).map(withRecentDirection),
      };
    },
    staleTime: FIVE_MIN,
  });

export const useMovers = () =>
  useQuery({ queryKey: ["movers"], queryFn: getMovers, staleTime: FIVE_MIN });

export const useMood = () =>
  useQuery({ queryKey: ["mood"], queryFn: getMood, staleTime: FIVE_MIN });

export const useAsset = (symbol) =>
  useQuery({
    queryKey: ["asset", symbol],
    queryFn: async () => {
      const data = await getAsset(symbol);
      return {
        ...data,
        asset: withRecentDirection(data?.asset),
      };
    },
    staleTime: FIVE_MIN,
    enabled: !!symbol,
  });

export const useHistory = (symbol, period) =>
  useQuery({
    queryKey: ["history", symbol, period],
    queryFn: () => getHistory(symbol, period),
    staleTime: FIVE_MIN,
    enabled: !!symbol,
  });
